var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"choose-city-wrapper"},[_c('city',{attrs:{"wrapper":"actionsheet-bd"},on:{"selectCity":_vm.getCity}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }